import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-all-report-icon",
  "use": "icon-all-report-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-all-report-icon\">\n  <path d=\"M1024.5 240v13.3L570.2 492.9c-36.9 19.5-81 19.7-118.2 0.7L0.5 261.8V240c0-35.3 28.7-64 64-64h896c35.3 0 64 28.7 64 64z\" /><path d=\"M1024.5 325.7V784c0 35.3-28.7 64-64 64h-896c-35.3 0-64-28.7-64-64V333.7l452 232c37.1 19.1 81.2 18.8 118.1-0.7l453.9-239.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/report/all-report-icon.svg
// module id = 6R34
// module chunks = 24